/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { z } from 'zod'

import type { ProjectTypeWithWorkplaceAI } from '@modules/ui-types/projects'

export const PROJECT_TYPES: ProjectTypeWithWorkplaceAI[] = [
  'elasticsearch',
  'observability',
  'security',
  'workplaceai',
] as const

export const filterSchema = z
  .object({
    type: z
      .string()
      .transform((s) => s && s.toLowerCase())
      .refine((s) => s && (PROJECT_TYPES as string[]).includes(s))
      .or(z.undefined())
      .catch(undefined),
    region_id: z
      .string()
      .transform((s) => s && s.toLowerCase())
      .or(z.undefined())
      .catch(undefined),
    organization_id: z.string().or(z.undefined()).catch(undefined),
    project_id: z
      .string()
      .transform((s) => s && s.toLowerCase())
      .or(z.undefined())
      .catch(undefined),
    include_deleted: z
      .preprocess((v) => v === 'true', z.boolean())
      .or(z.undefined())
      .catch(undefined),
  })
  .partial()

export type FilterSchema = z.infer<typeof filterSchema>
